<form edlFocusTrap [formGroup]="form" (ngSubmit)="ok(form)" novalidate>
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <edl-floating-label-container label="Action" for="verificationStatusSelect">
                        <select id="verificationStatusSelect" class="form-select" formControlName="VerificationStatus">
                            <option [ngValue]="null">Select</option>
                            <option [ngValue]="RequestVerificationStatus.APPROVED" *ngIf="isBulkAction() || requestHelpersService.canPerformVerificationAction(userRequest, requestItem, RequestVerificationStatus.APPROVED)">Approve</option>
                            <option [ngValue]="RequestVerificationStatus.DISAPPROVED" *ngIf="isBulkAction() || requestHelpersService.canPerformVerificationAction(userRequest, requestItem, RequestVerificationStatus.DISAPPROVED)">Disapprove</option>
                            <option [ngValue]="RequestVerificationStatus.CANCELLED" *ngIf="isBulkAction() || requestHelpersService.canPerformVerificationAction(userRequest, requestItem, RequestVerificationStatus.CANCELLED)">Cancel</option>
                            <option [ngValue]="RequestVerificationStatus.REOPEN" *ngIf="isBulkAction() || requestHelpersService.canPerformVerificationAction(userRequest, requestItem, RequestVerificationStatus.REOPEN)">Reopen</option>
                            <option [ngValue]="RequestVerificationStatus.FORGIVEN" *ngIf="isBulkAction() || requestHelpersService.canPerformVerificationAction(userRequest, requestItem, RequestVerificationStatus.FORGIVEN)">Forgive Follow-Up</option>
                            <option [ngValue]="RequestVerificationStatus.SKIPPED" *ngIf="!isBulkAction() && requestHelpersService.canPerformVerificationAction(userRequest, requestItem, RequestVerificationStatus.SKIPPED)">Bypass Approval</option>
                        </select>
                    </edl-floating-label-container>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="canDisplayNotificationsToggle()">
            <div class="col-sm-12">
                <label class="form-label">
                    <div>Send Email Notifications <span class="required">*</span></div>
                    <toggle-indicator formControlName="ShouldSendNotifications" OnLabel="Yes" OffLabel="No"></toggle-indicator>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="canDisplaySubmitHoursToggle()">
            <div class="col-sm-12">
                <label class="form-label">
                    <div>Submit to PERMS <span class="required">*</span></div>
                    <toggle-indicator
                        formControlName="ShouldSubmitToPerms"
                        OnLabel="Yes" OffLabel="No"  ></toggle-indicator>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="canDisplayShouldReserveSeat()">
            <div class="col-sm-12">
                <label class="form-label">
                    <div>Should Reserve Seat</div>
                    <toggle-indicator
                        formControlName="ShouldReserveSeat"
                        OnLabel="Yes" OffLabel="No"  ></toggle-indicator>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="form.get('VerificationStatus').value === RequestVerificationStatus.REOPEN">
            <div class="col-sm-12">
                <div class="form-group">
                    <edl-floating-label-container label="Select the stage for which this item should be reopened for user" for="reopenStageSelect">
                        <select id="reopenStageSelect" class="form-select" formControlName="ReopenStageId">
                            <option [ngValue]="null">Select</option>
                            <option [ngValue]="RequestReopenStageId.ReopenToUserStageId" *ngIf="reopenStages.length === 0 || requestItem.QfmRequired || requestItem.EvidenceRequired">Reopen to User</option>
                            <option *ngFor="let verificationStage of reopenStages" [innerHtml]="verificationStage.StageName" [ngValue]="verificationStage.StageID"></option>
                            <option [ngValue]="RequestReopenStageId.ReopenFollowupToUserStageId" *ngIf="shouldDisplayReopenFollowup()">Reopen Follow-Up to User</option>
                            <option *ngFor="let verificationStage of reopenFollowupStages" [innerHtml]="verificationStage.StageName" [ngValue]="verificationStage.StageID"></option>
                        </select>
                    </edl-floating-label-container>
                </div>
            </div>
        </div>
        <div *ngIf="!isBulkAction()" class="row">
            <div *ngIf="form.get('VerificationStatus').value !== RequestVerificationStatus.SKIPPED" class="col-sm-12">
                <div class="form-group">
                    <label for="verifyUserNote" class="form-label">
                        Note to User:
                        <button type="button" class="btn btn-link p-0 border-0 align-baseline"
                            [ngbPopover]="noteUserContent"
                            popoverTitle="Note to User"
                            triggers="mouseenter:mouseleave focus:blur"
                            aria-label="More information about Note to User">
                            <i class="fas fa-info-circle ms-1" aria-hidden="true"></i>
                        </button>
                    </label>
                    <ng-template #noteUserContent>
                        Upon approval, an email will be sent to the user notifying them of your approval.  If you would like to include a note in the email, enter it here.
                    </ng-template>
                    <textarea id="verifyUserNote" class="form-control" formControlName="UserNote" placeholder="Comments here ..."></textarea>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="form-group">
                    <label for="verifySupervisorNote" class="form-label">
                        Note to Approvers:
                        <button type="button" class="btn btn-link p-0 border-0 align-baseline"
                            [ngbPopover]="noteApproverContent"
                            popoverTitle="Note to Supervisor"
                            triggers="mouseenter:mouseleave focus:blur"
                            aria-label="More information about Note to Approvers">
                            <i class="fas fa-info-circle ms-1" aria-hidden="true"></i>
                        </button>
                    </label>
                    <ng-template #noteApproverContent>
                        Upon approval, an email will be sent to the next approver(s).  If you would like to include a note in the email, enter it here.
                    </ng-template>
                    <textarea id="verifySupervisorNote" class="form-control" formControlName="SupervisorNote" placeholder="Comments here ..."></textarea>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!isBulkAction() && (form.get('VerificationStatus').value === RequestVerificationStatus.APPROVED ||
            form.get('VerificationStatus').value === RequestVerificationStatus.SKIPPED ||
            form.get('VerificationStatus').value === RequestVerificationStatus.REOPEN)">
            <select-approvers
                class="col-sm-12"
                [form]="form.get('VerificationStages')"
                title="Approval Stages"
                additionalClass="alert-primary"
                [verificationStages]="requestItem.VerificationStages"
                [reopenStage]="reopenStage"
                [currentStage]="currentStage"
                [verificationStatus]="form.get('VerificationStatus').value"
                [reopenStageId]="form.get('ReopenStageId')?.value"
                (approverChanged)="updateDueDateValidator()"
            ></select-approvers>
            <select-approvers
                *ngIf="requestItem.FollowupRequired"
                class="col-sm-12"
                [form]="form.get('FollowupVerificationStages')"
                title="Follow-Up Approval Stages"
                additionalClass="alert-secondary"
                [verificationStages]="requestItem.FollowupVerificationStages"
                [reopenStage]="reopenStage"
                [currentStage]="currentStage"
                [verificationStatus]="form.get('VerificationStatus').value"
                [reopenStageId]="form.get('ReopenStageId')?.value"
                (approverChanged)="updateDueDateValidator()"
            ></select-approvers>
        </div>
        <div class="row" *ngIf="shouldDisplayFollowUpSection(form.get('VerificationStatus') && form.get('VerificationStatus').value)">
            <div class="col-sm-12">
                <div class="form-group">
                    <div class="alert alert-secondary mt-3" role="info">
                        <ng-template [ngIf]="isBulkAction()" [ngIfElse]="elseBlock">
                            "Follow-Up Due Date" is optional. Select a due date.<br /><br /><b>Note:</b> The follow-up due date will only be applied to the requests that have not had a follow-up due date set by a previous approver.
                         </ng-template>
                         
                         <ng-template #elseBlock>
                           "Follow-Up Due Date" is required for this request. Select a due date. <b>Note:</b> If the follow-up requirements for this request have multiple approvers, each approver will have the option to select and/or edit the due date.
                         </ng-template> 
                       
                        <div class="mt-3"><label for="verifyFollowupDueDate" class="form-label"> <span *ngIf="!form.get('FollowupDueDate').valid" class="required"><b>*</b></span>Follow-Up Due Date:</label></div>
                        <div> <edl-date-picker id="verifyFollowupDueDate" placement="top" formControlName="FollowupDueDate"></edl-date-picker></div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="this.form.get('VerificationStatus').value === RequestVerificationStatus.REOPEN && shouldDisplayReopenWarning" class="alert alert-danger mt-3" role="alert">
            <strong>Warning - </strong>If you continue, any users that have already submitted follow-up, will be required to resubmit their follow-up.
        </div>
    </div>
    <div class="modal-footer">
        <button [ladda]="busy" type="submit" class="btn btn-primary" [disabled]="form.invalid ">Ok</button>
        <button *ngIf="canClose" [ladda]="busy" type="button" class="btn btn-info" (click)="cancel()">Cancel</button>
    </div>
</form>